import React from 'react';
import { Button } from './ui/button';
import { Calendar } from 'lucide-react';
import { useBooking } from '../context/BookingContext';

export const MobileCTA = () => {
  const { openBooking } = useBooking();

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-slate-950/95 backdrop-blur border-t border-slate-800 p-3"
      data-testid="mobile-cta-bar"
    >
      <div className="flex flex-col gap-2">
        {/* Phone numbers row */}
        <div className="flex items-center justify-center gap-4 text-sm">
          <a
            href="tel:+12342051010"
            className="text-white font-semibold hover:text-orange-400 transition-colors"
          >
            (234) 205-1010
          </a>
          <span className="text-slate-600">|</span>
          <a
            href="tel:+12342051043"
            className="text-white font-semibold hover:text-orange-400 transition-colors"
          >
            (234) 205-1043
          </a>
        </div>
        {/* Book button */}
        <Button
          onClick={openBooking}
          className="w-full btn-gradient-orange text-white h-11 font-semibold rounded-lg shadow-lg"
        >
          <Calendar className="h-5 w-5 mr-2" />
          Book Appointment
        </Button>
      </div>
    </div>
  );
};
